// extracted by mini-css-extract-plugin
export default {"root":"E1s_E6","title":"RvBsja","timer":"GqSPj4"};